import moment from 'moment'
import prettyMilliseconds from 'pretty-ms'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Column, Padding } from '../../../..'
import { ValueGroup, Label, Value } from './MediaItem.style'
import { useSize } from '../../../../utils'
import { useAppSelector } from '../../../../../reducers'
import * as ChainsSelectors from '../../../../../reducers/chains'

const formatDate = (date) => {
    if (!date) return 'N/A'
    return moment(new Date(date)).fromNow()
}

const LeftColumn = ({ isBeingUploaded, media }) => {
    const { t } = useTranslation()
    const { isMobile } = useSize()
    const { chain_id, created_at, length, name } = media || {}
    const chain = useAppSelector(
        state => ChainsSelectors.selectChainByID(state, chain_id)
    )

    return (
        <Column width={isMobile ? '65%' : '55%'}>
            <Padding top fullHeight size="ssm">
                <Padding left fullHeight size={isMobile ? 'sm' : 'md'}>
                    {isMobile && (
                        <>
                            <ValueGroup nomargin>
                                <Value>{name}</Value>
                            </ValueGroup>
                            <ValueGroup>
                                <Label>{formatDate(created_at)}</Label>
                            </ValueGroup>
                            <ValueGroup>
                                {!isBeingUploaded && (
                                    <>
                                        <Label>{`${t('file-length')}:`}</Label>
                                        <Value>{`${prettyMilliseconds(length)}`}</Value>
                                    </>
                                )}
                            </ValueGroup>
                            {chain && (
                                <ValueGroup>
                                    <Label>{t('Chain')}:</Label>
                                    <Value>{chain.name}</Value>
                                </ValueGroup>
                            )}
                        </>
                    )}
                    {!isMobile && (
                        <>
                            <ValueGroup nomargin>
                                <Label>{`${t('file-name')}:`}</Label>
                                <Value>{name}</Value>
                            </ValueGroup>
                            <ValueGroup>
                                <Label>{`${t('file-added')}:`}</Label>
                                <Value>{formatDate(created_at)}</Value>
                            </ValueGroup>
                            <ValueGroup>
                                {!isBeingUploaded && (
                                    <>
                                        <Label>{`${t('file-length')}:`}</Label>
                                        <Value>{`${prettyMilliseconds(length)}`}</Value>
                                    </>
                                )}
                            </ValueGroup>
                            {chain && (
                                <ValueGroup>
                                    <Label>{t('Chain')}:</Label>
                                    <Value>{chain.name}</Value>
                                </ValueGroup>
                            )}
                        </>
                    )}
                </Padding>
            </Padding>
        </Column>
    )
}

LeftColumn.propTypes = {
    isBeingUploaded: PropTypes.bool,
    media: PropTypes.shape({
        id: PropTypes.number,
        playlists: PropTypes.arrayOf(PropTypes.shape({})),
    }),
}

LeftColumn.defaultProps = {
    isBeingUploaded: false,
    media: {},
}

export default LeftColumn
